import { render, staticRenderFns } from "./DeletesConfirm.vue?vue&type=template&id=b377af8a&scoped=true&"
import script from "./DeletesConfirm.vue?vue&type=script&lang=js&"
export * from "./DeletesConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeletesConfirm.vue?vue&type=style&index=0&id=b377af8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b377af8a",
  null
  
)

export default component.exports